import axiosInstance from "./api";

// presigned url
export async function getPresignedUrl(fileName, fileType) {
  const params = new URLSearchParams({ fileName, fileType });
  const res = await axiosInstance.get(`/portfolio/presigned-url?${params}`);
  return res.data; // { uploadURL, fileURL, key }
}

export const getProfile = async () => {
  const response = await axiosInstance.get("/portfolio");
  return response.data;
};

export const updateProfile = async (data) => {
  const response = await axiosInstance.put("/portfolio", data);
  return response.data;
};

// export const getAllOrganizers = async () => {
//   const response = await axiosInstance.get("/portfolio/all");
//   return response.data.portfolios;
// };

export const getAllOrganizers = async (page = 1, limit = 10) => {
  const { data } = await axiosInstance.get(
    `/portfolio/all?page=${page}&limit=${limit}`,
  );
  return data; // { portfolios, pagination: { totalPages, currentPage, ... } }
};

export const getAllVolunteers = async () => {
  const response = await axiosInstance.get("/portfolio/all/volunteer");
  return response.data.portfolios;
};

// NEW: Get portfolio by ID
export const getPortfolioById = async (id) => {
  const response = await axiosInstance.get(`/portfolio/${id}`);
  return response.data.portfolio;
};

// NEW: Get portfolio by userId
export const getPortfolioByUserId = async (userId) => {
  const response = await axiosInstance.get(`/portfolio/user/${userId}`);
  return response.data;
};

// — Customer Profile
export const getCustomerProfile = async () => {
  const { data } = await axiosInstance.get("/customer/profile");
  return data;
};

export const updateCustomerProfile = async (data) => {
  const res = await axiosInstance.put("/customer/profile", data);
  return res.data;
};

export const changeCustomerPassword = async (payload) => {
  const { data } = await axiosInstance.put(
    "/customer/profile/password",
    payload,
  );
  return data;
};
